import { render, staticRenderFns } from "./BaseInputField.vue?vue&type=template&id=bd7d2aca"
import script from "./BaseInputField.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInputField.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports